import ru from './ru.json'
import en from './en.json'
import az from './az.json'

const localizations = {
  "ru-RU" : ru,
  "en-EN" : en,
  "az-AZ" : az
}

export function localize(code, format = null) {
  const locale = localStorage.getItem('cfgLocale') || 'en-EN'
  const res = localizations[locale][code]
  if (!res) {
    console.warn(`Localization for code '${code}' not found in locale '${locale}'`)
    return localizations['en-EN'][code] || code
  }

  if (!format) {
    return res
  }
  
  switch (format) {
    case 'uppercase':
      return res.toUpperCase()
    case 'lowercase':
      return res.toLowerCase()
    case 'capitalize':
      return res.charAt(0).toUpperCase() + res.slice(1)
    default:
      console.warn(`Unknown format '${format}' for localization code '${code}'`)
      return res
  }
}

export function setLocale(locale) {
  localStorage.setItem('cfgLocale', locale)
}